module.exports = __webpack_public_path__ + "static/qr-payment-in-restaurant-8bc9e4dd50a1db31f91669a341ff25d3.jpg";